import { createAction } from "@reduxjs/toolkit";

// --------------------
// Account deactivation
// --------------------
export const deactivateAccount = createAction("DEACTIVATE_ACCOUNT");
export const deactivateAccountStart = createAction("DEACTIVATE_ACCOUNT_START");
export const deactivateAccountFailure = createAction<any>("DEACTIVATE_ACCOUNT_FAILURE");
export const deactivateAccountSuccess = createAction<any>("DEACTIVATE_ACCOUNT_SUCCESS");

// --------------------
// Account reactivation
// --------------------
export const reactivateAccount = createAction<any>("REACTIVATE_ACCOUNT");
export const reactivateAccountStart = createAction("REACTIVATE_ACCOUNT_START");
export const reactivateAccountFailure = createAction<any>("REACTIVATE_ACCOUNT_FAILURE");
export const reactivateAccountSuccess = createAction<any>("REACTIVATE_ACCOUNT_SUCCESS");

// --------
// App meta
// --------
export {
  fetchAppMeta,
  fetchAppMetaStart,
  fetchAppMetaSuccess,
  fetchAppMetaFailure,
} from "@/store/slices/appMeta";

// -------
// Auth
// -------
export {
  refreshCurrentUserData,
  refreshCurrentUserDataStart,
  refreshCurrentUserDataSuccess,
  refreshCurrentUserDataFailure,
  initializeCurrentUserData,
  initializeCurrentUserDataStart,
  initializeCurrentUserDataSuccess,
  initializeCurrentUserDataFailure,
  attemptLogout,
  logoutStart,
  logoutDone,
  attemptLogin,
  loginStart,
  loginSuccess,
  loginFailure,
  resetPassword,
  resetPasswordStart,
  resetPasswordSuccess,
  resetPasswordFailure,
} from "@/store/slices/auth";

// -------
// Content
// -------
export {
  fetchContents,
  fetchContentsStart,
  fetchContentsSuccess,
  fetchContentsFailure,
} from "@/store/slices/contents";

// ------------------
// ORGANIZATION PLANS
// ------------------
export {
  fetchOrganizationPlanItems,
  fetchOrganizationPlanItemsStart,
  fetchOrganizationPlanItemsSuccess,
  fetchOrganizationPlanItemsFailure,
  manuallyAddOrganizationPlanItems,
  manuallyRemoveOrganizationPlanItems,
  manuallyReplaceOrganizationPlanItems,
  manuallyClearOrganizationPlanItems,
} from "@/store/slices/organizationPlanItems";

// -------------------------
// ORGANIZATION PLAN BUCKETS
// -------------------------
export {
  fetchOrganizationPlanBuckets,
  fetchOrganizationPlanBucketsStart,
  fetchOrganizationPlanBucketsSuccess,
  fetchOrganizationPlanBucketsFailure,
} from "@/store/slices/organizationPlanBuckets";

// ----------------------
// ORGANIZATION RESPONSES
// ----------------------
export {
  fetchOrganizationResponses,
  fetchOrganizationResponsesStart,
  fetchOrganizationResponsesSuccess,
  fetchOrganizationResponsesFailure,
} from "@/store/slices/organizationResponses";

// -----------------
// ORGANIZATION SETS
// -----------------
export {
  fetchOrganizationSets,
  fetchOrganizationSetsStart,
  fetchOrganizationSetsSuccess,
  fetchOrganizationSetsFailure,
} from "@/store/slices/organizationSets";

// -----------------
// ORGANIZATION TEAM
// -----------------
export {
  fetchOrganizationTeam,
  fetchOrganizationTeamStart,
  fetchOrganizationTeamSuccess,
  fetchOrganizationTeamFailure,
} from "@/store/slices/organizationTeam";

// ----------------
// Password: Change
// ----------------
export {
  changePassword,
  changePasswordStart,
  changePasswordSuccess,
  changePasswordFailure,
  clearChangePasswordErrors,
} from "@/store/slices/changePassword";

// ----------------
// Password: Forgot
// ----------------
export {
  attemptChangePassword,
  forgotPasswordEditEmail,
  forgotPasswordStart,
  forgotPasswordSuccess,
  forgotPasswordFailure,
} from "@/store/slices/forgotPassword";

// -----------------
// Programs
// -----------------
export {
  fetchPrograms,
  fetchProgramsStart,
  fetchProgramsSuccess,
  fetchProgramsFailure,
  fetchProgram,
  fetchProgramStart,
  fetchProgramSuccess,
  fetchProgramFailure,
} from "@/store/slices/programs";

// ------------
// Registration
// ------------
export {
  registerInit,
  registerStart,
  registerSuccess,
  registerFailure,
  attemptRegister,
} from "@/store/slices/auth";
